module.exports = __webpack_public_path__ + "static/lightbulb-92de0d4340085c09cb96c4b9e5c3e667.png";